import { Config3d } from '@ff-scene-plugins/gift-shared/GiftVariantOptions';
import { Scene3d } from 'ff-preview-3d';
import { importPreview3d } from './importPreview3d';

export type Engine3d = {
    scene3d: Scene3d;
    dispose: () => void;
};

export const loadEngine3d = async (
    canvas: HTMLCanvasElement,
    config3d: Config3d
): Promise<Engine3d> => {

    const assetResponse = await fetch(config3d.modelAssetUrl, { mode: 'cors' });
    const model3d = JSON.parse(await assetResponse.text());

    const preview3d = await importPreview3d();
    const scene3d = await preview3d.createInteractive3dScene(model3d, canvas, config3d);

    let frameId = 0;

    const animationLoop = () => {
        scene3d.updateAll();
        frameId = requestAnimationFrame(animationLoop);
    };

    animationLoop();

    return {
        scene3d,
        dispose: () => {
            cancelAnimationFrame(frameId);
            scene3d.dispose();
        }
    };
};